import { routePrefix } from '@/utils/routes/routes';
import React from 'react';
import { useNavigate } from 'react-router';

const HomeEditBannerOurServices = ({ themeData }: any) => {
  const navigate = useNavigate();

  const navigateToPricing = () => {
    navigate("/pricing");
  };

  return (
    <section className="our-service-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div
              className="section-title text-center aos-init mb-5"
              data-aos="zoom-in-up"
            >
              <h2>{themeData?.theme_5?.home?.section_our_services?.title}</h2>
            </div>
          </div>
        </div>
        <div className="our-service-inner aos-init" data-aos="zoom-in-up">
          <div className="our-service-wrapper">
            <div className="row">
              {themeData?.theme_5?.home?.section_our_services?.service_section.services.map(
                (item: any) => {
                  return (
                    <>
                      <div className="col-md-4 d-flex col-sm-6">
                        <div className="service-widget flex-fill" style={{ backgroundColor: item?.bg_color ? `#${item?.bg_color}` : '' }}>
                          <div className="services-img">
                            <img
                              src={item.service_image}
                              alt=""
                              className="img-fluid"
                            />
                          </div>
                          <h4
                            style={{
                              color: item?.color ? `#${item?.color}` : '',
                              cursor: item?.service_link ? 'pointer' : 'default'
                            }}
                            onClick={() => item?.service_link && navigate(`${routePrefix}${item?.service_link}`)}
                          >
                            {item.service_title}
                          </h4>
                          <p style={{ color: item?.color ? `#${item?.color}` : '' }}>{item.service_description}</p>
                          <span style={{ color: item?.color ? `#${item?.color}` : '' }}>{item.service_text}</span>
                        </div>
                      </div>
                    </>
                  );
                }
              )}

            </div>
            <div className="view-price">
              <button
                type="button"
                className="btn btn-primary hover-btn"
                style={{
                  background: `#${themeData?.theme_5?.home?.section_our_services?.btn_group?.btn1?.bg_color}`,
                  color: `#${themeData?.theme_5?.home?.section_our_services?.btn_group?.btn1?.color}`,
                }}
                onClick={navigateToPricing}
              >
                {
                  themeData?.theme_5?.home?.section_our_services?.btn_group
                    ?.btn1?.text
                }
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeEditBannerOurServices;
